import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { OrderHeadGet } from '@app/services/orderhead.service';

@Component({
    selector: 'tt-order-head-custact-ac',
    templateUrl: './order-head-custact-ac.component.html',
    styleUrls: ['./order-head-custact-ac.component.css'],
})
export class OrderHeadCustactAcComponent implements OnChanges {
    @Input()
    public get?: OrderHeadGet;

    public grid?: GridOptions;

    public readGrid() {
        if (!this.get) return;

        if (!this.grid) {
            this.grid = new Grid().setRememberId('linked_custactac').setLoadDataFunction({ method: 3661, parameters: () => ({ order_internal_no: this.get?.order_internal_no }) });
        } else {
            this.grid.gridfunc?.read();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['get']) {
            this.readGrid();
        }
    }
}
